import React, { useState } from "react";
import "./PopupConfirmation.scss";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { useTranslation } from "react-i18next";

const PopupConfirmation = ({ handleConfirmationPopupClose, onSaveClick}) => {

  const { i18n, t } = useTranslation();

  return (
    <div className="popup-containers-confirmation">
      <div className="cross-img"><img src={Image_Url.CROSSPOP} onClick={handleConfirmationPopupClose} /></div>
      <div className="popup-confirmation-text">
        <span className="popup-confirmation-text">{t("confirmationpopup.savechanges")}</span>
      </div>
      <div className="popup-confirmation-text">
        <span className="popup-confirmation-your-changes-text">{t("confirmationpopup.dontsave")}</span>
      </div>
      <div className="popup-button-container">
          <button className="cancel-button-popup" onClick={handleConfirmationPopupClose}>{t("popupack.cancel")}</button>
          <button className="confirmation-save-button" onClick={onSaveClick}>
          {t("saveconfirmationpopup.save")}
          </button>
      </div>

    </div>
  );
};

export default PopupConfirmation;
